<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>
        Students in {{ model.ServicesOffered[0] }}
        {{ model.Name }}
      </v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <template>
        <v-btn
          dark
          outline
          class="mb-2"
          v-show="!isNewStudentForm"
          @click="showAddStudentForm"
          >Add Student</v-btn
        >
        <v-btn outline dark class="mb-2" v-show="showBackButon()" @click="back"
          >Back</v-btn
        >
      </template>
    </v-toolbar>

    <template v-if="!progressBar">
      <student-form
        v-show="isNewStudentForm"
        :isStudentFormEnabled="isNewStudentForm"
        :model="studentEmptyModel"
        :dropdowns="dropdowns"
        :batches="batches"
        formContext="add"
        v-on:studentFormCancelEvent="onFormCancel"
        v-on:studentFormAddEvent="onFormSave"
      ></student-form>
    </template>

    <v-card v-show="!isNewStudentForm">
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <!--           <v-flex xs12>
            <v-card-text>
              <v-list
                dense
                v-for="(value, propertyName, index) in displayFields"
                :key="index"
              >
                <v-list-tile>
                  <v-list-tile-content>{{ value }}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{
                    model[value]
                  }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-flex>-->
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="students"
              :pagination.sync="pagination"
              :loading="progressBar"
              item-key="Id"
              class="elevation-1"
              select-all
              :rows-per-page-items="rowsPerPageItems"
            >
              <template v-slot:progress>
                <v-progress-linear
                  slot="progress"
                  color="primary"
                  height="4"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr :active="isSelected(props.item.Id)">
                  <td>
                    <v-checkbox
                      v-model="selected"
                      primary
                      hide-details
                      @click.stop="selectItem(props.item.Id)"
                      :value="props.item.Id"
                    ></v-checkbox>
                  </td>
                  <td
                    v-for="(value, index) in tableDisplayFields"
                    :key="index"
                    class="text-xs-center"
                    @click="getStudentDetails(props.item.Id)"
                  >
                    {{ props.item[value] }}
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <td :colspan="headers.length + 1">
                  <!-- <v-btn color="primary" dark class="mb-2" v-show="selected.length>0" @click="removeStudents">Remove Students</v-btn> -->
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-show="selected.length > 0"
                    @click="sendForApproval"
                    >Send For Approval
                  </v-btn>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-show="selected.length > 0"
                    @click="markAttendance">
                    Mark Attendance
                  </v-btn>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-show="selected.length > 0"
                    @click="sendReports">
                    Send Reports
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import Rules from "../rules";
import StudentStore from "../db/studentStore";
import StudentForm from "./StudentForm";
import dbStore from "../db/dbStore";
import Utils from "../utils";
import config from "../config";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "BatchView",
  components: {
    StudentForm
  },
  data: function() {
    return {
      id: this.$route.params.id,
      deleteDialog: false,
      valid: true,
      isEditStudentForm: false,
      isNewStudentForm: false,
      context: "BatchView", //StudentView, StudentEdit, StudentAdd
      progressBar: false,
      fab: false,
      dobPicker: false,
      students: [],
      allStudents: [],
      dropdowns: {},
      batches: [],
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        sortBy: "name",
        rowsPerPage: 30
      },
      selected: [],
      headers: [
        {
          text: "First Name",
          align: "center",
          sortable: true,
          value: "FirstName"
        },
        { text: "Last Name", value: "LastName", align: "center" },
        { text: "Email", value: "Email", align: "center" },
        { text: "Status", value: "Status", align: "center" }
      ],
      tableDisplayFields: ["FirstName", "LastName", "Email", "Status"],
      displayFields: ["Name", "Center", "NoOfStudents", "StartDate", "EndDate"],
      studentEmptyModel: {
        DlNo: "",
        FirstName: "",
        LastName: "",
        Email: "",
        DateOfBirth: "",
        Phone: "",
        Address: "",
        Year: "",
        Month: "",
        Age: "",
        Gender: "",
        Location: "",
        MothersName: "",
        FathersName: "",
        IdType: "",
        IdNo: "",
        MaritalStatus: "",
        Religion: "",
        Occupation: "",
        Qualification: "",
        Category: "",
        DateOfEnrolment: "",
        IdConfirmedByPartner: "",
        Pin: "",
        Background: "",
        AnnualIncome: "",
        HaveDisability: ""
      },
      editedModel: {
        Id: "",
        Name: "",
        Center: "",
        StartDate: "",
        EndDate: "",
        NoOfStudents: "",
        Students: ""
      },
      model: {
        Id: "",
        Name: "",
        Center: "",
        StartDate: "",
        EndDate: "",
        NoOfStudents: "",
        Students: "",
        ServicesOffered: ""
      }
    };
  },
  watch: {},
  created() {
    this.getData();
  },
  computed: {
    getRules() {
      var rulesObject = Rules.getComponentRules("Student");
      //console.log(rulesObject)
      return rulesObject;
    },
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },
  methods: {
    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("dropdowns");
      this.dropdowns = await dbStore.getItems();
      this.dropdowns = this.dropdowns[0];
      delete this.dropdowns.Id;
      dbStore.setCollectionName("batches");
      this.batches = await dbStore.getItems();
      //console.log(this.id, this.batches);
      this.model = Utils.getItemFromListWithId(this.batches, this.id);
      //console.log(this.model);
      this.editedModel = this.model;
      dbStore.setCollectionName("students");
      this.allStudents = await dbStore.getItems();
      //console.log(this.students);
      this.mapIdsWithNames(this.students);
      this.batches = await this.getBatchesForCurrentCenter(this.batches)
      this.progressBar = false;
      this.selected = [];

      this.students = this.allStudents.filter(item => {
        return item.Batch == this.id;
      });
    },

    
    async getBatchesForCurrentCenter(batches) {
      var temp = []
      var centerId = this.login_details.centerId
      await batches.forEach(async batch => {
        if(centerId == 0 || batch.CenterId === centerId) {
          temp.push(batch)
        }
      });
      return temp
    },

    showAddStudentForm() {
      this.isNewStudentForm = true;
    },

    onFormCancel(value) {
      console.log(value);
      if (value) {
        this.isNewStudentForm = false;
      }
    },
    onFormSave(value) {
      if (value) {
        this.isNewStudentForm = false;
        this.getData();
      }
    },

    async sendForApproval() {
      let response;
      try {
        //console.log(this.model)
        //#TODO change to enums
        var json = { Status: "Pending Approval" };
        var students = this.getUnApprovedStudents();
        if (students.length >= 1) {
          dbStore.setCollectionName("students");
          response = await dbStore.updateItemsProperties(students, json);
          if (response.isStateChanged) {
            this.getData();
          }
        } else {
          console.log("No students to be approved!");
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error Sending Approval : " + err);
      }
    },

    async sendReports() {
      let response;
      try {
        let students = this.getPassedStudents();
        // Trigger report generation api
        //this.getStudentInfo(students);
        this.sendCerts(students);
      } catch (err) {
        console.log("Error Selecting students for generating reports : " + err);
      }
    },

    async markAttendance() {
      let response;
      try {
        //console.log(this.model)
        var time = Date.now();
        var payload = this.getTodayAttendanceOfAllStudentsInBatch();

        response = await StudentStore.markAttendance(payload, time);

        if (response.isCommitted) {
          this.getData();
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error marking attendance : " + err);
      }
    },

    //#TODO move to generalized component
    isSelected(Id) {
      if (this.selected.indexOf(Id) > -1) {
        return true;
      } else {
        return false;
      }
    },

    //#TODO move to generalized component
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else {
        var ids = [];
        this.model.Students.forEach(element => {
          ids.push(element.Id);
        });
        this.selected = ids;
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    //#TODO move to generalized component
    selectItem(Id) {
      var isExists = this.isSelected(Id);
      //console.log(Id + " exists "+ isExists + " index -> "+index)
      if (isExists) {
        //value already exists so remove
        var index = this.selected.indexOf(Id);
        this.selected.splice(index, 1);
        return false;
      } else {
        //value doesnt exists so add it up
        this.selected.push(Id);
        return true;
      }
    },

    //#TODO move to generalized component
    getSelectedStudents() {
      //set students with approved status
      var self = this;
      var students = [];
      this.students.forEach(function(value) {
        var Id = value.Id;
        self.selected.forEach(element => {
          if (element == Id) students.push(element);
        });
      });

      return students;
    },

    getUnApprovedStudents() {
      //set students with approved status
      var self = this;
      var students = [];
      this.students.forEach(function(student) {
        var Id = student.Id;
        self.selected.forEach(element => {
          //#TODO change to enums
          if (element == Id && student.Status.toUpperCase() !== "APPROVED")
            students.push(element);
        });
      });

      return students;
    },

    getPassedStudents() {
      //set students with approved status
      var self = this;
      var students = [];
      this.students.forEach(function(student) {
        var Id = student.Id;
        self.selected.forEach(element => {
          //#TODO check whether the selected student is passed or not
          students.push(element);
        });
        //Reset the selected students
        self.selected = [];
      });
      return students;
    },

    getTodayAttendanceOfAllStudentsInBatch() {
      var self = this;
      var payload = {};
      this.students.forEach(function(value) {
        var Id = value.Id;
        payload[Id] = { status: false, studentInfo: value };
        self.selected.forEach(element => {
          if (element == Id) {
            payload[Id]["status"] = true;
          }
        });
      });

      return payload;
    },

    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },

    async getStudentInfo(student_ids) {
      if (student_ids.length === 0) return {};
      else {
        // Get the center details of the batch of students
        dbStore.setCollectionName("centers");
        let center = await dbStore.getItem(this.login_details.centerId);

        let certs = {
          "type": "ndlm",
          "body": [],
          "email": center.center_manager.email
        };

        dbStore.setCollectionName("studentsprofile");

        await this.asyncForEach(student_ids, async (element) => {
          let studentProfileInfo = await dbStore.getItem(element);
          let cert_body = {
            //#TODO change type from static to dynamic data
            "filename": studentProfileInfo.IdNo,
            "name":
              studentProfileInfo.FirstName +
              " " +
              studentProfileInfo.LastName,
            "donor": center.donor,
            "aadhar_no": studentProfileInfo.IdNo,
            "partner": center.partner
          }
          certs.body.push(cert_body);
        });
        return certs;
      }
    },

    async sendCerts(ids) {
      let certs = await this.getStudentInfo(ids);
      console.log(certs);
      console.log(JSON.stringify(certs));
      //TODO move post methods to different library
      var url = config().cloudFunctions.sendReceipt;
      fetch(url, {
        method: "POST",
        body: JSON.stringify(certs),
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(function(response) {
        let body = response.json();
        console.log("Fetch Response: " + JSON.stringify(body));
        return body;
      })
      .catch(err => {
        console.log("Fetch Error: " + err);
      });
    },
    removeStudents() {
      //set students with approved status
      var students = [];
      var self = this;
      try {
        this.model.Students.forEach(function(value) {
          var Id = value.Id;
          console.log(Id);
          self.selected.forEach(element => {
            if (element != Id) students.push(Id);
          });
        });
        //console.log(students)
        this.model.Students = students;
        console.log(this.model);
        dbStore.setCollectionName("batches");

        var response = dbStore.updateItem(this.model);
        if (response.isStateChanged) {
          this.$router.push({ name: "batch", params: { id: this.id } });
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
    },

    getStudentDetails(Id) {
      this.$router.push({
        name: "student",
        params: { batchId: this.id, id: Id }
      });
    },

    mapIdsWithNames(students) {
      //console.log(students)
      var studentNames = [];
      //console.log(this.model);
      students.forEach(item => {
        var Id = item.Id;
        
        if (this.model.Students != undefined && this.model.Students != "") {
          this.model.Students.forEach(student => {
            if (student == Id) studentNames.push(item);
          });
        }
      });
      this.students = studentNames;
      //console.log(this.students);
      this.model.Students = studentNames;
    },

    /* async deleteStudent() {
      let response;
      try {
        //console.log(this.model)
        dbStore.setCollectionName("students")
        response = await dbStore.deleteItem(this.id)
        if (response.isStateChanged) {
          this.$router.push({ name: "batches" });
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error deleting batch : " + err);
      }
    }, */

    editItem() {
      this.isEditStudentForm = true;
      this.context = "edit";
      this.editedModel = Object.assign({}, this.model);
    },

    deleteItem() {
      this.deleteDialog = true;
    },

    remove() {
      //this.deleteStudent();
      this.deleteDialog = false;
    },

    back() {
      this.$router.push({ name: "batches" });
    },

    cancel() {
      this.isEditStudentForm = false;
      this.context = "view";
    },

    showBackButon() {
      if (this.isEditStudentForm || this.isNewStudentForm) {
        return false;
      } else {
        return true;
      }
    },

    
    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>
